import React from 'react';
import IntlMessages from 'helpers/IntlMessages';
import MultilingualHtmlParser from 'components/Multilingual/MultilingualHtmlParser';
import { Card } from 'react-bootstrap';
import { BestPracticeDetailsPageLayoutProps } from '../BestPracticeDetailsPageLayout';
import { Link } from 'react-router-dom';
import ContextHelp from 'components/common/ContextHelp';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';

interface HtmlContentCardProps extends BestPracticeDetailsPageLayoutProps {
  title: string;
  htmlContent: Record<string, string>;
  contextHelpId?: string;
  hasEditPermission?: boolean;
}
const HtmlContentCard = ({
  title,
  htmlContent,
  isBestPracticeDesigner,
  editUrl,
  contextHelpId,
  isTranslator,
  hasEditPermission,
}: HtmlContentCardProps): React.ReactElement => {
  return (
    <Card className="mb-3 card-full-width-img">
      <Card.Body>
        <Card.Title className="d-flex justify-content-between">
          <div className="text-primary h4">
            <IntlMessages id={title} />
            {contextHelpId && <ContextHelp contextHelpId={contextHelpId} />}
          </div>
          <Link to={{ pathname: editUrl }}>
            {(isBestPracticeDesigner || isTranslator || hasEditPermission) && <EditOutlineIcon
              size={25}
              className="mr-1 mb-2 float-right accent-color" />}
          </Link>
        </Card.Title>
        <div className="text-normal html-parser">
          <MultilingualHtmlParser multilingualHtml={htmlContent} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default HtmlContentCard;
